import axios from 'axios';
import initRequestInterceptor from './apiInterceptorRequest';
import initResponseInterceptor from './apiInterceptorResponse';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
});

// Attach interceptors immediately
initRequestInterceptor(api);
initResponseInterceptor(api);

export { api };
